module.exports = __webpack_public_path__ + "assets/img/campaign-image-2.55efdb9f.png";